import { render, staticRenderFns } from "./SystemTagPicker.vue?vue&type=template&id=754e5309&scoped=true"
import script from "./SystemTagPicker.vue?vue&type=script&lang=ts"
export * from "./SystemTagPicker.vue?vue&type=script&lang=ts"
import style0 from "./SystemTagPicker.vue?vue&type=style&index=0&id=754e5309&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e5309",
  null
  
)

export default component.exports